import { Injectable } from '@angular/core';
import { ILegalEntitiesBusinessesResponse } from './models/shared.model';

const HISTORY_STORAGE_KEY = 'legalEntitySearchHistory';
const MAX_HISTORY_ITEMS = 10;

@Injectable({
  providedIn: 'root'
})
export class LegalEntityHistoryService {

  constructor() { }

  /**
   * Add a legal entity to the search history
   * Maintains only the last 10 items, removing duplicates
   */
  addToHistory(legalEntity: ILegalEntitiesBusinessesResponse): void {
    let history = this.getHistory();

    // Remove if already exists (to avoid duplicates)
    history = history.filter(item => item.legalEntityId !== legalEntity.legalEntityId);

    // Add to the beginning
    history.unshift(legalEntity);

    // Keep only the last 10 items
    if (history.length > MAX_HISTORY_ITEMS) {
      history = history.slice(0, MAX_HISTORY_ITEMS);
    }

    // Save to localStorage
    localStorage.setItem(HISTORY_STORAGE_KEY, JSON.stringify(history));
  }

  /**
   * Get the search history from localStorage
   */
  getHistory(): ILegalEntitiesBusinessesResponse[] {
    try {
      const historyJson = localStorage.getItem(HISTORY_STORAGE_KEY);
      if (historyJson) {
        return JSON.parse(historyJson);
      }
    } catch (error) {
      console.error('Error reading legal entity history from localStorage:', error);
    }
    return [];
  }

  /**
   * Clear the search history
   */
  clearHistory(): void {
    localStorage.removeItem(HISTORY_STORAGE_KEY);
  }
}
